module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n         " + _vm._s(_vm.$t('static.productBundles.index.title')) + " (" + _vm._s(_vm.products.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "search.title",
      "value": _vm.search,
      "clearable": true
    },
    on: {
      "keydown": _vm.onChangeSearch
    }
  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', [(_vm.products.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.productBundle.noDataMsg')) + "\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'productBundles.create'
      }
    }
  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.productBundle.noDataBtn')) + "\n          ")])], 1)], 1) : [_c('div', {
    staticClass: "flex stretch wrap"
  }, _vm._l((_vm.products.items), function(p, i) {
    return _c('v-card', {
      key: i,
      nativeOn: {
        "click": function($event) {
          return _vm.editProduct(p)
        }
      }
    }, [_c('label', {
      staticClass: "cardLabel w-full"
    }, [_c('span', {
      staticClass: "cardBadge"
    }, [_vm._v(_vm._s(_vm.$t(("static.products.types." + (_vm.camelize(p.productType))))))]), _vm._v(" "), (_vm.hasInventory && (!p.containsAlcohol && p.productTypeGroup === 'Beverage')) ? _c('span', {
      staticClass: "cardBadge card-yellow"
    }, [_vm._v(_vm._s(_vm.$t("static.products.labels.alcoholFree")))]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-external-link pull-right",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editProductNewTab(p)
        }
      }
    })]), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('form.products.price.label')) + ": ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.productBundleGroupPrice) + " NOK")]), _vm._v(" "), (p.description) ? _c('div', {
      staticClass: "cardinnerBox"
    }, [_c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-file-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" \n                  " + _vm._s(p.description))])])]) : _vm._e()])
  }), 1)]], 2)]) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.products.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d92c84a6","hasScoped":false}!./src/app/pages/withNavigation/productBundles/index/index.html
// module id = 3128
// module chunks = 1